import React from 'react';

import Button from '@/common/components/ui/Button';
import StandardInputText from '@/common/components/input/StandardInputText';
import { AddIcon, DeleteIcon } from '@/assets/icons/button';

import { UnitBuilderData } from 'course-types';

interface IProps {
  units: UnitBuilderData[];
  onChange: (field: string, value: string, unitIndex?: number, subunitIndex?: number) => void;
  onAddSubunit: (unitIndex: number) => void;
  onRemoveSubunit: (unitIndex: number, subunitIndex: number) => void;
}

const SubunitsStep: React.FC<IProps> = ({ units, onChange, onAddSubunit, onRemoveSubunit }) => (
  <div className='flex flex-col gap-2 w-full'>
    <div className='flex flex-col gap-1 bg-surface_gray_200 rounded-lg p-3 border border-border_gray_300'>
      <p className='text-base'>Add subunits to each unit in your course.</p>
      <p className='text-sm text-text_gray_900'>
        Subunits help break down your units into smaller, more manageable sections.
      </p>
    </div>

    <div className='max-h-[35vh] min-h-[200px] overflow-y-auto'>
      {units.map((unit, unitIndex) => (
        <div
          key={unitIndex}
          className='mb-2 last:mb-0 bg-surface_gray_200 rounded-lg p-3 border border-border_gray_300'
        >
          <div className='mb-2'>
            <h3 className='text-base font-semibold'>Unit {unitIndex + 1}</h3>
            <p className='text-sm text-text_gray_900'>{unit.name}</p>
          </div>

          <div className='flex flex-col gap-2'>
            {unit.subunits.map((subunit, index) => (
              <div
                key={index}
                className='bg-surface_gray_50 rounded-lg p-3 border border-border_gray_300'
              >
                <div className='flex justify-between items-center mb-2'>
                  <h3 className='text-base font-semibold'>Subunit {index + 1}</h3>
                  <Button text={true} onClick={() => onRemoveSubunit(unitIndex, index)} delete>
                    <DeleteIcon className='w-[20px] h-[20px]' />
                  </Button>
                </div>

                <StandardInputText
                  id={`subunit-${unitIndex}-${index}-name`}
                  label='Subunit Name'
                  isRequired={true}
                  value={subunit.name}
                  onChange={(e) => onChange('name', e.target.value, unitIndex, index)}
                />
              </div>
            ))}

            <Button text={true} onClick={() => onAddSubunit(unitIndex)} className='w-fit'>
              <AddIcon className='w-[20px] h-[20px] mr-1' /> Add Subunit
            </Button>
          </div>
        </div>
      ))}
    </div>
  </div>
);

export default SubunitsStep;
